import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PaginatedResponse } from "../pagination.model";
import { IResponse } from "../response.model";
import { TemplateApiService } from "../template-api.service";
import { IRodada } from "../testes/rodada.service";


export interface ILicenca extends IResponse {
    acesso_pessoal: string,
    ativo: boolean,
    data_criacao: string,
    data_inicio: string | undefined,
    data_fim: string,
    disponivel_ate: string | undefined,
    disponivel_de: string | undefined,
    dono: string,
    progresso: number,
    liberado: boolean,
    equipe: {uuid: string, nome: string} | null,
    grupo: string,
    teste: {
        uuid: string, 
        nome: string, 
        /** url da capa */
        capa: string
    },
    teste_antecessor: {
        nome: string,
        uuid: string
    } | null
}

export interface IRecomendacaoRodada extends IResponse{
    rodada: IRodada,
    recomendacao: string
}

@Injectable()
export class LicencasService extends TemplateApiService<ILicenca> {

    public override setBaseUrl(params: {}) {
        this.baseUrl = `licencas`;
    }

    public getRecomendacoes(idLicenca: string): Observable<PaginatedResponse<IRecomendacaoRodada>>{
        const route = this.getBaseUrl() + `/${idLicenca}/recomendacoes-rodadas`;
        return this.apiService.get(route);
    }

    override get(params?: any): Observable<PaginatedResponse<ILicenca>> {
        const route = this.getBaseUrl();
        return this.apiService.get(route, {...params, ordenacao: '-data_vinculo_com_acesso_pessoal'}) as Observable<PaginatedResponse<ILicenca>>;
    }
}
